import Grid from '@material-ui/core/Grid/Grid';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { reduxForm, Field, change, formValueSelector, Form } from 'redux-form/immutable';
import MenuItem from '@material-ui/core/MenuItem';
import moment from 'moment';
import { fromJS, List } from 'immutable';

import { showDialog, hideDialog, showWarning } from '../../../redux/actions/dialogs';
import { fetchCustomersPromise, saveCustomerAddressPromise } from '../../../redux/routines';

import { name } from '../../../utils/helper';
import { required, future } from '../../../utils/formvalidation';
import {
  renderSelect,
  renderTextField,
  renderCustomerAutoComplete,
  renderMuiDatePicker,
  renderAddressAutoComplete
} from '../../../utils/reduxforms';

import { isDialogVisibleSelector } from '../../../redux/selectors';
import { ADDRESS_DIALOG, CREATE_JOB_DIALOG, CUSTOMER_DIALOG } from '../../../redux/constants/dialogs';

const futureInclusive = future(true);

const isAfterOrEqualStart = (value, values) => {
  const result = moment(value).startOf('d').isSameOrAfter(moment(values.get('start')).startOf('d'));
  return result ? undefined : 'End date must be after start date';
};

class Page1 extends React.Component {
  state = {};

  handleAddCustomer = (name) => {
    this.props.showDialog(CUSTOMER_DIALOG, {
      customer: { name },
      onSave: this.handleSaveContact
    });
  }

  handleSaveContact = (customer) => {
    console.log('newcustomer', customer);
    this.props.change('customer', fromJS(customer));
  }

  handleAddAddress = (type) => (line1) => {
    this.props.showDialog(ADDRESS_DIALOG, {
      address: { line1 },
      onSave: this.handleSaveAddress,
      onSuccess: this.handleSaveAddressSuccess(type),
    });
  }

  handleSaveAddress = (address) => {
    return this.props.saveCustomerAddress({
      customer: this.props.customer,
      address,
    });
  }

  handleSaveAddressSuccess = (type) => (address) => {
    console.log('newaddress', address);
    this.props.change(type, fromJS(address));
  }

  // handleSelectCustomer = (customer) => {
  // console.log('handleSelectCust', customer.get('contacts').toJS());
  // if (newCustomerId === '0') {
  //   this.props.showDialog(CUSTOMER_DIALOG);
  // } else if (newCustomerId !== prevCustomerId) {
  //   const customer = this.props.customers.find((cust) => cust.id === newCustomerId);
  //   if (customer) {
  //     this.showCustomerDependentFields(customer);
  //   } else {
  //     console.log('new customer not present', newCustomerId);
  //   }
  // }
  // };

  // showCustomerDependentFields = (customer) => {
  //   const contacts = customer.contacts ? this.addNewContact().concat(toArray(customer.contacts).sort((a, b) => sortStrings(a.name, b.name))) : this.addNewContact();
  //   const addresses = customer.addresses ? this.addNewAddress().concat(toArray(customer.addresses)) : this.addNewAddress();
  //   this.setState({
  //     contacts,
  //     addresses,
  //   });
  // };

  // handleNewCustomerAdded = (customer) => {
  //   console.log('onNewCustomerAdded', customer);
  //   this.props.hideDialog(CUSTOMER_DIALOG);
  //   if (customer) {
  //     this.props.change('customerId', customer.id);
  //     // this.showCustomerDependentFields(customer);
  //   } else {
  //     this.props.change('customerId', null);
  //   }
  // };

  // handleSelectPrimaryContact = (evt, primaryContactId) => {
  //   console.log('handleSelectPrimaryContact', primaryContactId);
  //   const { customerId } = this.props;
  //
  //   if (primaryContactId === '0') {
  //     if (!customerId) {
  //       this.props.showWarning('Invalid Customer', 'Please select a customer');
  //       return null;
  //     }
  //     this.props.showDialog(CONTACT_DIALOG, {
  //       onRequestClose: this.handleRequestCloseContact,
  //     });
  //   }
  // };

  // handleRequestCloseContact = (contact) => {
  //   console.log('handleRequestCloseContact', contact);
  //   if (contact) {
  //     const { contacts } = this.state;
  //     this.setState({
  //       contacts: contacts.concat([contact]).sort((a, b) => sortStrings(a.name, b.name)),
  //     }, () => {
  //       this.props.change('primaryContactId', contact.id);
  //       const customer = this.props.customers.find((c) => c.id === this.props.customerId);
  //       this.props.saveCustomer(fromJS(_.update(customer, ['contacts'], (ctcts = {}) => _.assign({}, ctcts, { [contact.id]: contact }))));
  //     });
  //   }
  //   this.props.hideDialog(CONTACT_DIALOG);
  // };

  // handleSelectOrigin = (evt, addressId) => {
  //   console.log('handleSelectOrigin', addressId);
  //   const { customerId } = this.props;
  //
  //   if (addressId === '0') {
  //     if (!customerId) {
  //       showWarning('Invalid Customer', 'Please select a customer');
  //       return null;
  //     }
  //
  //     this.props.showDialog(ADDRESS_DIALOG, {
  //       onRequestClose: (addr) => this.handleRequestCloseAddress('origin', addr),
  //     });
  //   }
  // };
  //
  // handleSelectDestination = (evt, addressId) => {
  //   console.log('handleSelectDestination', addressId);
  //   const { customerId } = this.props;
  //
  //   if (addressId === '0') {
  //     if (!customerId) {
  //       showWarning('Invalid Customer', 'Please select a customer');
  //       return null;
  //     }
  //
  //     this.props.showDialog(ADDRESS_DIALOG, {
  //       onRequestClose: (addr) => this.handleRequestCloseAddress('destination', addr),
  //     });
  //   }
  // };

  // handleRequestCloseAddress = (type, address) => {
  //   console.log('handleRequestCloseAddress', address);
  //   this.props.hideDialog(ADDRESS_DIALOG);
  //
  //   if (address) {
  //     const { addresses } = this.state;
  //     this.setState({
  //       addresses: addresses.concat([address]),
  //     }, () => {
  //       this.props.change(`${type}Id`, address.id);
  //       const customer = this.props.customers.find((c) => c.id === this.props.customerId);
  //       this.props.saveCustomer(fromJS(_.update(customer, ['addresses'], (addrs = {}) => _.assign({}, addrs, { [address.id]: address }))));
  //     });
  //   }
  // };

  // handleStartDateChange = (event, start) => {
  //   if (this.state.end && !isValidDates(start, this.state.end)) {
  //     this.setState({ futureEndDateError: 'End Date must be After Start' });
  //     return null;
  //   }
  //   if (isFutureDate(start)) {
  //     this.setState({
  //       futureStartDateError: '',
  //       start,
  //     });
  //     return this.props.setStart(this.props.job, start);
  //   }
  //   this.setState({ futureStartDateError: 'Start date must be in the future' });
  // };
  //
  // handleEndDateChange = (event, end) => {
  //   if (this.state.start && !isValidDates(this.state.start, end)) {
  //     this.setState({ futureEndDateError: 'End Date must be After Start' });
  //     return null;
  //   }
  //   if (isFutureDate(end)) {
  //     this.setState({
  //       futureEndDateError: '',
  //       end,
  //     });
  //     return this.props.setEnd(this.props.job, end);
  //   }
  //   this.setState({ futureEndDateError: 'End date must be in the future' });
  // };

  // addNewContact() {
  //   return [{
  //     id: '0',
  //     name: ' -- Add New Contact --',
  //   }];
  // }
  //
  // addNewAddress() {
  //   return [{
  //     id: '0',
  //     line1: ' -- Add New Address --',
  //   }];
  // }

  render() {
    const { handleSubmit, customer } = this.props;

    return (<Form onSubmit={handleSubmit}>
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Field
            name="reference"
            component={renderTextField}
            label="Reference"
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <Field
            name="customer"
            component={renderCustomerAutoComplete}
            label="Customer"
            fullWidth
            validate={required}
            fetchCustomers={this.props.fetchCustomers}
            allowCreate
            onAdd={this.handleAddCustomer}
          />
        </Grid>
        <Grid item xs={4}>
          <Field
            name="primaryContact"
            component={renderSelect}
            label="Primary Contact"
            fullWidth
            disabled={!customer}
          >
            {(customer ? customer.get('contacts') || new List() : new List()).map((contact) => {
              return (<MenuItem key={contact.get('id')} value={contact}>{name(contact.toJS())}</MenuItem>);
            })}
          </Field>
        </Grid>
        <Grid item xs={12}>
          <Field
            name="description"
            component={renderTextField}
            label="Description"
            fullWidth
            multiline
          />
        </Grid>

        <Grid item xs={6}>
          <Field
            name="origin"
            component={renderAddressAutoComplete}
            label="Origin"
            fullWidth
            validate={required}
            disabled={!customer}
            allowCreate
            onAdd={this.handleAddAddress('origin')}
            addresses={customer ? (customer.get('addresses') || new List()).toJS() : []}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            name="destination"
            component={renderAddressAutoComplete}
            label="Destination"
            fullWidth
            validate={required}
            disabled={!customer}
            allowCreate
            onAdd={this.handleAddAddress('destination')}
            addresses={customer ? (customer.get('addresses') || new List()).toJS() : []}
          />
        </Grid>

        <Grid item xs={6}>
          <Field
            name="start"
            label="Start"
            component={renderMuiDatePicker}
            validate={[required, futureInclusive]}
            autoOk
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            name="end"
            label="End"
            component={renderMuiDatePicker}
            validate={[required, futureInclusive, isAfterOrEqualStart]}
            autoOk
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Field
            name="notes"
            component={renderTextField}
            label="Notes"
            fullWidth
            multiline
          />
        </Grid>
      </Grid>
    </Form>);
  }
}

Page1.propTypes = {
  // fetchCustomers: PropTypes.func.isRequired,
  customer: PropTypes.object,
  customers: PropTypes.array,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
  showWarning: PropTypes.func.isRequired,

  customerId: PropTypes.string,
  start: PropTypes.object,

  change: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: CREATE_JOB_DIALOG, // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  initialValues: fromJS({
    start: moment().startOf('d').add(1, 'd').toDate(),
    end: moment().startOf('d').add(1, 'd').toDate(),
    // profile: null,
    // created: { at: new Date().toISOString() },
  }),
})(Page1);

function mapStateToProps(state) {
  const selector = formValueSelector(CREATE_JOB_DIALOG);

  return {
    isDialogVisible: isDialogVisibleSelector(state),
    start: selector(state, 'start'),
    customer: selector(state, 'customer'),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      showDialog,
      hideDialog,
      change: change(CREATE_JOB_DIALOG),
      showWarning,
    }, dispatch),
    ...bindPromiseCreators({
      fetchCustomers: fetchCustomersPromise,
      saveCustomerAddress: saveCustomerAddressPromise,
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Jobs/CreateJobDialog/Page1.js